<div class="forgot-password-container">
  <h4 class="heading font-bureau">
    @if (!tokenExists()) {
      Reset your password
    } @else {
      Set your new password
    }
  </h4>

  @if (tokenExists()) {
    <div class="description">
      @if (isOtpValidated()) {
        Please choose a new password that you haven't used before.
      } @else {
        Please enter the 6-digit code sent to your email id.
      }
    </div>
  }


  <form class="forgot-password-form auth-form-wrapper">
    <app-text-input
      label="Email"
      [error]="errorMessages['email']"
      placeholder="Email"
      [parentFormGroup]="emailForm"
      controlName="email"
      (checkForErrors)="checkForEmailFormErrors($event)"
    />

    @if (tokenExists()) {
      @if (isOtpValidated()) {
        <app-password-input
          label="New Password"
          [error]="errorMessages['password']"
          placeholder="New Password"
          [parentFormGroup]="passwordForm"
          controlName="password"
          (checkForErrors)="checkForPasswordFormErrors($event)"
        />

        <app-password-input
          label="Confirm password"
          [error]="errorMessages['confirmPassword']"
          placeholder="Confirm password"
          [parentFormGroup]="passwordForm"
          controlName="confirmPassword"
            [isConfirmPassword]="true"
          (checkForErrors)="checkForPasswordFormErrors($event)"
        />
      } @else {
        <app-otp-input
          label="Enter OTP"
          [error]="errorMessages.otp"
          placeholder="0"
          [parentFormGroup]="passwordForm"
          controlName="otp"
          (checkForErrors)="checkForPasswordFormErrors($event)"
        />
      }
    }

    @if (isOtpValidated() || !tokenExists()) {
      <app-primary-button
        class="submit-button"
        [isDisabled]="isLoading$ | async"
        [isLoading]="isLoading$ | async"
        (handleClick)="submit($event)"
      >
        {{ (tokenExists() ? 'RESET PASSWORD' : 'SEND VERIFICATION CODE') }}
      </app-primary-button>
    }


    @if (tokenExists()) {
      @if (!isOtpValidated()) {
        <app-primary-button
          (click)="resendOtp()"
          [isDisabled]="(timeLeft() !== 0) || (isLoading$ | async)"
        >
          @if (timeLeft() > 0) {
            Resend OTP in {{ timeLeft() }} seconds
          } @else {
            {{ 'RESEND OTP' }}
          }
        </app-primary-button>
      }
      <app-outlined-button
        (click)="reset()"
      >
        Start Over
      </app-outlined-button>
    }
  </form>

  <div class="login-prompt">
    Remember your password? <a href="/login">Sign In</a>
  </div>
</div>
